module.exports = __webpack_public_path__ + "img/lock-document-white.aa3d1017.svg";